<crm-form-loading-indicator [loadingStatus]="loadingStatus">
  <form class="crm-model-driven-form" form-content [formGroup]="formGroup">
    <crm-vertical-nav-tab>
      @for (fieldGroup of renderableFieldGroups; track fieldGroup; let first = $first) {
        @if (fieldGroup.editableFieldCount > 0) {
          <crm-vertical-nav-card
            [label]="
              fieldGroup.description
                ? (fieldGroup.description | translate)
                : ('STANDARD_FIELD_GROUPS.CUSTOM_FIELDS' | translate)
            "
            [active]="first"
          >
            <mat-card appearance="outlined">
              <mat-card-content class="crm-model-card-content">
                @for (renderableField of fieldGroup.fields; track renderableField) {
                  <crm-renderer-selector [handler]="renderableField"></crm-renderer-selector>
                }
                @if (first && !isEditing) {
                  @for (field of associationFormFields(); track field) {
                    <glxy-form-field>
                      <glxy-label>{{ 'ASSOCIATION_FORM.TITLE' | translateByObjectType: field.type }}</glxy-label>
                      <crm-object-association-form-field
                        insideInputWrapper
                        [objectType]="field.type"
                        [(associationsList)]="field.associations"
                        (associationsListChange)="associationsUpdated()"
                      ></crm-object-association-form-field>
                      @if (associationRequiredError()) {
                        <glxy-error>{{
                          'CREATE_PAGE.SAVE.ASSOCIATIONS_REQUIRED' | translateByObjectType: objectType
                        }}</glxy-error>
                      }
                    </glxy-form-field>
                  }
                }
              </mat-card-content>
            </mat-card>
          </crm-vertical-nav-card>
        }
      }
      @for (renderableFieldGroup of readonlyRenderableFieldGroups; track renderableFieldGroup) {
        @for (renderableField of renderableFieldGroup.fields; track renderableField) {
          <crm-renderer-selector [handler]="renderableField"></crm-renderer-selector>
        }
      }
    </crm-vertical-nav-tab>
    @if (!readOnly) {
      <glxy-sticky-footer>
        <ng-template [ngTemplateOutlet]="formButtons"></ng-template>
      </glxy-sticky-footer>
    }
  </form>
</crm-form-loading-indicator>
<ng-template #formButtons>
  <crm-form-button-group
    [submitButtonText]="submitButtonText | translate"
    [cancelButtonText]="cancelButtonText | translate"
    [savingStatus]="savingStatus"
    (clickedOnSubmit)="onSubmit()"
    (clickedOnCancel)="onCancel()"
  ></crm-form-button-group>
</ng-template>
